import AcceleratorDoc from "../../../models/AcceleratorDoc";
import { ExtractedFieldData } from "../../../models/extraction/ExtractedFieldData";
import { HighlightColours } from "../../../models/HighlightColors";
import { HighlightObjectModified } from "../../../models/HighlightObject";
import { PageSection } from "../../../models/matchers/PageSection";
import { Section } from "../../../models/matchers/Section";
import { useKeyValueHighlight } from "../../hooks/dlfEditing/useKeyValueHighlight";
import { useSpanHighlights } from "../../hooks/useSpanHighlights";
import { KeyValueDlfEditor, KeyValueDlfEditorProps } from "./KeyValueDlfEditor";

export { HighlightableKeyValueDlfEditor };

type Props = {
  highlightKey: string;
  acceleratorDoc: AcceleratorDoc;
  extractedData: ExtractedFieldData;
  index?: number;
  /**
   * True if the KeyValueDlfEditor is visible. This will change which highlight(s) are sent to the ImageViewer.
   */
  open: boolean;
  /**
   * True if a different DlfEditor is selected.
   */
  otherOpen: boolean;
} & KeyValueDlfEditorProps;

const HighlightableKeyValueDlfEditor = (props: Props) => {
  useKeyValueHighlight(
    props.index ?? 0,
    props.matcher,
    props.highlightKey,
    props.open,
    // wth
    function highlightKvCoordsModified(
      newCoordinates: HighlightObjectModified,
      type,
    ) {
      const section: Section =
        type === "KEY"
          ? props.matcher.keyMatcher.section
          : props.matcher.valueMatcher.section;
      // TODO: make this a switch statement
      if (section.getSectionType() !== "PAGE") {
        throw new Error(
          `HighlightableKeyValueDlfEditor does not support ${type} Sections with type ${section.getSectionType()}`,
        );
      }

      const pageSection = section as PageSection;
      pageSection.topLeft.setX(newCoordinates.leftXPercent);
      pageSection.topLeft.setY(newCoordinates.topYPercent);
      pageSection.bottomRight.setX(newCoordinates.rightXPercent);
      pageSection.bottomRight.setY(newCoordinates.bottomYPercent);

      if (type === "KEY") {
        props.matcher.keyMatcher.section = pageSection;
      } else {
        props.matcher.valueMatcher.section = pageSection;
      }
      props.update(props.matcher);
    },
  );

  useSpanHighlights(
    props.highlightKey,
    HighlightColours.getHighlightColor(props.index ?? 0),
    props.acceleratorDoc,
    props.extractedData,
    // show highlights only if we're open, and nothing else is
    !(props.otherOpen && !props.open),
    !(props.otherOpen && !props.open),
  );

  return <KeyValueDlfEditor {...props} />;
};
